/**
 * Format date/time as m/d/Y H:i a (e.g. 02/02/2025 03:45 PM).
 * Use for all list and detail pages.
 */
export function formatDateTime(iso) {
  if (iso == null || iso === "") return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "-";
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  const hour = d.getHours();
  const min = String(d.getMinutes()).padStart(2, "0");
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${month}/${day}/${year} ${hour12}:${min} ${ampm}`;
}
